/**
 * 레이 설정 — 지금은 브라우저(localStorage)에만 저장한다.
 * 계정에 저장(`user.lay_prefs`)하는 것은 마이그레이션과 함께 다음 단계(기획 docs/ops/lay-ai-operations-plan.md §3-5 · 통합 시안 2 채택 2026-09-09).
 *
 *   view        : "float" | "side"                       — 레이 위젯 보기 방식(떠 있는 패널 A / 화면 옆에 붙이기 B)
 *   assist      : boolean                                — 화면 도우미(「화면에서 고르기」 도구 노출, C)
 *   tts         : boolean                                — 답을 소리로 읽어 주기(음성 1단계 전까지는 표시만)
 *   historyView : "timeline" | "questions" | "inbox"     — 「내 대화 기록」 보기 방식
 *   seenAnswers : string[]                               — 받은 편지함에서 열어 본 운영팀 답변(항목 id)
 */
import { HISTORY_VIEWS } from "./layHistory";

const KEY = "laeebly_lay_prefs";
export const LAY_VIEWS = ["float", "side"];
// me (2026-09-13 맞춤 답변): 레이가 답하기 전에 내 상황(채널·검수·정산 단계·금액·계좌 뒤 4자리)을 읽어 답한다. 기본 켜짐 — 끄면 가이드만으로 답한다.
const DEFAULTS = { view: "float", assist: true, tts: false, me: true, historyView: "timeline", seenAnswers: [] };

export function readLayPrefs() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    const out = { ...DEFAULTS, ...(parsed && typeof parsed === "object" ? parsed : {}) };
    if (!HISTORY_VIEWS.includes(out.historyView)) out.historyView = DEFAULTS.historyView;
    if (!LAY_VIEWS.includes(out.view)) out.view = DEFAULTS.view;
    out.assist = out.assist !== false;
    out.tts = out.tts === true;
    out.me = out.me !== false;
    if (!Array.isArray(out.seenAnswers)) out.seenAnswers = [];
    return out;
  } catch (e) {
    return { ...DEFAULTS };
  }
}

export function writeLayPrefs(patch) {
  const next = { ...readLayPrefs(), ...(patch || {}) };
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* 사생활 모드 등 — 화면은 기본값으로 동작 */ }
  try { window.dispatchEvent(new CustomEvent("laeebly:lay-prefs", { detail: next })); } catch (e) { /* noop */ }
  return next;
}
